
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Energy_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 33.42 42.46","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Energy_svg__st0",attrs:{"d":"M22.38.3c-.41-.12-.82-.22-1.24-.3l-.59 2.92c.34.07.68.15 1.01.24L22.38.3zM9.93 5.75L7.97 3.5c-.32.28-.63.58-.93.88l2.14 2.08c.24-.25.49-.49.75-.71zM15.42 2.97L14.77.06c-.42.09-.84.2-1.24.33l.89 2.84c.32-.09.66-.18 1-.26zM28.95 4.15c-.3-.3-.62-.59-.95-.86l-1.91 2.29c.26.22.52.45.76.69l2.1-2.12zM32.89 10.67c-.13-.41-.27-.81-.42-1.21l-2.77 1.1c.13.32.24.65.34.98l2.85-.87zM6.44 10.8l-2.8-1.03c-.15.4-.28.81-.39 1.22l2.87.8c.09-.34.2-.67.32-.99zM30.47 16.64l-.02.12c-.04.31-.09.62-.16.92l2.92.6c.08-.37.14-.75.19-1.14l.02-.12-2.95-.38zM27.6 23.19l2.27 1.93c.27-.32.54-.66.79-1.01l-2.42-1.74c-.2.28-.41.56-.64.82zM17.08 5.83c-3.4.38-6.22 2.5-7.55 5.68-1.33 3.18-.84 6.68 1.29 9.38 1.69 2.12 2.68 5.95 2.75 8.47.01.36.31.65.67.65h7.75c.36 0 .66-.28.67-.65.09-2.99 1.27-6.52 2.87-8.6 2.3-2.98 2.57-6.9.71-10.22-1.85-3.31-5.36-5.12-9.16-4.71zm7.19 13.95c-1.6 2.08-2.8 5.3-3.13 8.39l-.03.23h-2.05v-8.69l2.4-2.4L20.15 16l-2.01 2.01-2.03-2.04-1.32 1.32 2.41 2.42v8.69h-2.08l-.03-.23c-.26-2.4-1.2-6-3.02-8.29-1.76-2.23-2.16-5.13-1.07-7.76 1.1-2.64 3.43-4.4 6.25-4.71 3.13-.34 6.04 1.13 7.57 3.86 1.56 2.78 1.35 6.04-.55 8.51zM12.47 35.55h11.32v1H12.47zM12.47 38.45h11.32v1H12.47zM12.47 41.35h11.32v1H12.47zM6.23 15.81L0 29.79h5.75v12.67l6.23-14.47H6.23z"}})])
          )
        }
      }
    